import React from "react";
import { Box } from "@mui/material";
import config from "../../config";

const defaultImage = "/product.png";

const MediaGallery = ({ images }) => {
  const fetchImage = (image) => {
    if (image && image.url) {
      return image.url;
    }
    if (image && image.image) {
      return `${config.baseURL}/fetch-file/${image.image}`;
    }
    return defaultImage;
  };

  return (
    <Box
      sx={{
        width: "100%",
        borderWidth: 1,
        borderColor: "#D1D1D1",
        borderRadius: 4,
        // mt: { xs: 2, sm: 1 },
        backgroundColor: "var(--bg-input)",
      }}
    >
      {images?.length > 0 ? (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
            p: 2,
            maxHeight: 250,
            overflowY: "auto",
            justifyContent: "center",
          }}
        >
          {images.map((img, index) => (
            <Box
              key={index}
              sx={{
                border: 1,
                borderRadius: 2,
                padding: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 120,
                height: 120,
                backgroundColor: "var(--bg-paper)",
              }}
            >
              <img
                src={fetchImage(img)}
                alt={`Product image ${index}`}
                style={{ maxWidth: "100%", maxHeight: "100%" }}
              />
            </Box>
          ))}
        </Box>
      ) : (
        <Box
          sx={{
            height: 120,
          }}
        ></Box>
      )}
    </Box>
  );
};

export default MediaGallery;
